import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-8 md:mb-12">
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950 mb-2">
              热门专题
            </h2>
            <p className="text-sm text-foreground-500">精选热门漫画专题，一站式畅读经典与热门作品</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {carouselItems.map((item) => (
              <article
                key={item.id}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="aspect-[8/5] overflow-hidden bg-background-100">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading={item.id > 3 ? 'lazy' : undefined}
                  />
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-full">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500">{item.stat}</span>
                  </div>
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2 leading-snug">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                    {item.description}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}